import { createSelector } from 'selectors'

import { form } from './constant'

const getQuestionnaireSelect = () => createSelector<HTMLSelectElement>({ selector: form.selector.questionnaireSelect })

export const getFormComponents = () => ({
	questionnaireSelect: getQuestionnaireSelect(),
})
